import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal } from 'antd';
import { useState, useRef, useEffect, forwardRef, useImperativeHandle }  from 'react';
import CustomSelect  from './CustomSelect.jsx';
import CustomCheckbox  from './CustomCheckbox.jsx';
import axiosInstance from './axiosInstance.js';
import moment from 'moment';
import './Form.css'
import {tabitem,handleException, getval, formitems} from './Utils.jsx'
import {rightitems} from './defs.js'
const { TabPane } = Tabs;
const { TextArea } = Input;



const FormUser = forwardRef(({entity="TUser", id,open,writeRight, ...props},ref)=>{

    const [form] = Form.useForm();
    const [recid, setRecid] = useState(0);
    const [loading, setLoading] = useState(true);   
    const cbFinish = useRef(null) 
    const url = '/dataservice'
    const urlsave = '/usersave'
    const urlresetpwd = '/userresetpwd'
    
    useImperativeHandle(ref, () => ({
        open(id,cb=null) { if(id) loadData(id); else handleNew(); cbFinish.current = cb }
    }))

    useEffect(() => { if(id) loadData(id); else handleNew(); }, [open]);
 
    const items = [
        {name:"login",        label:"Login",required:true,       ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"name",         label:"Jméno",required:true,       ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"phone",        label:"Telefon",                   ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"email",        label:"E-mail",                    ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"enable",       label:"Aktivní",                  ctrl: (pp)=>(<CustomCheckbox  {...pp} />)},
        {name:"admin",        label:"Administrátor",             ctrl: (pp)=>(<CustomCheckbox  {...pp} />)},
        {name:"users",        label:"Uživatelé",                 ctrl: (pp)=>(<CustomSelect {...pp} scalar={true} items={rightitems} />)},
        {name:"loans",        label:"Půjčky",                    ctrl: (pp)=>(<CustomSelect {...pp} scalar={true} items={rightitems} />)},
        {name:"assign_loan",  label:"Přidělení půjčky",          ctrl: (pp)=>(<CustomCheckbox  {...pp} />)},
        {name:"settings",     label:"Nastavení",                 ctrl: (pp)=>(<CustomCheckbox  {...pp} />)}
    ]
    const tabs = [
        {name:"Uživatel",   columns:1, items:items.slice(0,6)},
        {name:'Práva',      columns:1, items:items.slice(6,5+4)},
    ]
        

    function translate(r,dir){
        return r      
    }

    async function loadData(recid) { 
		setRecid(recid)
        setLoading(true);	
        try {
			let response = await axiosInstance.post(url, {cmd:'get-record',entity:entity,recid:recid});
            var r = response.data.record
            r = translate(r,0)  
            form.setFieldsValue(r);        
		} catch (err) {  
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function saveData() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlsave, {recid:recid, ...translate(form.getFieldsValue(),1)});
            message.success('Záznam byl úspěšně uložen');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function resetPassword() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlresetpwd, {recid:recid});
            message.success('Heslo bylo úspěšně resetováno');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    
    function handleChange(changedValues, allValues) { 
        //console.log('allvalues',allValues)
        console.log('changedvalues',changedValues)          
    };

    function handleNew(){
        setRecid(0)
        form.resetFields() 
    };

    function handleCopy(){
        setRecid(0) 
    };
  
    function handleFinish(values){
        console.log('Form Values:', values);
        saveData();
        if(cbFinish.current) cbFinish.current(values);
    };
    
    return (
        <div>
        <Form
            form={form}
            name={'userForm'}
            labelCol={{ span: 10 }}
            onFinish={handleFinish}
            onValuesChange={handleChange}
            disabled={!writeRight}
        >           
            <Tabs defaultActiveKey="1">
                {tabs.map(t=>(tabitem(t.name,t.items,{},{},t.columns)))}
            </Tabs>
            
            <Form.Item wrapperCol={{ offset: 8, span: 24 }}>
                <Button type="primary" htmlType="submit">Uložit</Button>
                <Button onClick={handleNew} style={{ marginLeft: '10px' }}>Nový</Button>
                {/*<Button onClick={handleCopy} style={{ marginLeft: '10px' }}>Kopie</Button>*/}
                <Button onClick={() => resetPassword()} style={{ marginLeft: '10px' }} disabled={!writeRight || !recid }>Reset hesla</Button>
            </Form.Item>
        </Form>
        </div>
    )
})
export default FormUser;




